import { createSelector } from "@reduxjs/toolkit";
import _ from "lodash";
import { selectArticlegroupsMap } from "./selectArticlegroupsMap";

export const selectArticlegroupParentsMap = createSelector([selectArticlegroupsMap], (articlegroupsMap) => {
  const result: PartialRecord<string, string[]> = {};

  for (const articlegroup of _.values(articlegroupsMap)) {
    if (!articlegroup) {
      continue;
    }

    const parents = new Set<string>();

    if (articlegroup.parentId && articlegroupsMap[articlegroup.parentId] != null) {
      parents.add(String(articlegroup.parentId));
    }
    if (articlegroup.category) {
      parents.add(articlegroup.category);
    }

    if (parents.size > 0) {
      result[articlegroup.id] = Array.from(parents);
    }
  }
  return result;
});
